export const clearFormInputs = function () {
  document.querySelectorAll("[data-turbolinks-cache='false']").forEach(function (element) {
    element.querySelectorAll("input").forEach(function (input) {
      input.value = "";
    });
    element.querySelectorAll('[type="submit"]').forEach(function (el) { el.removeAttribute('disabled') })
  });
};